import { Box, ButtonGroup, HighlightContainer, Typography } from '@qbe/ads-core';
import { config } from 'config';
import * as React from 'react';

import type { SnackbarSurveyChildrenProps } from '~/components-ds/Snackbar';
import { useAppContent } from '~/hooks';

const SurveyNPS = ({ close }: SnackbarSurveyChildrenProps) => {
  const { getTextContent: getSharedContent } = useAppContent({ basePath: 'shared' });

  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.confirmation',
    tokens: {
      homeLink: () => getSharedContent('qbeHome'),
      privacyLink: () => getSharedContent('privacyLink'),
    },
  });

  return (
    <>
      <Box sx={{ marginBottom: 4 }}>
        <Typography variant="h4" component="h2" sx={{ marginBottom: 1 }}>
          {getTextContent('surverynpssnackbar.text.title')}
        </Typography>
        <Typography sx={{ marginBottom: 2 }}>
          {getTextContent('surverynpssnackbar.text.caption')}
        </Typography>
        <HighlightContainer>
          <Typography variant="body2" sx={{ marginBottom: 3 }}>
            {getJSXContent('surverynpssnackbar.text.description')}
          </Typography>
        </HighlightContainer>
      </Box>

      <ButtonGroup
        fullWidthInMobile
        primaryBtnProps={{
          label: getTextContent('buttons.startSurvey'),
          'data-track': 'nps-start-survey',
          onClick: () => {
            window.open(config.npsSurveyUrl, '_blank', 'noopener noreferrer');
            close();
          },
        }}
        secondaryBtnProps={{
          label: getTextContent('buttons.dismiss'),
          'data-track': 'nps-dismiss',
          onClick: close,
        }}
      />
    </>
  );
};

export default SurveyNPS;
